import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import CustomSpinner from "../../../../../../components/customSpinner/CustomSpinner";

const ImageWrapper: React.FC<{ alt: string; url: string }> = ({ url, alt }) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      <div style={{ position: "relative", width: "100%", height: "100%" }}>
        <LazyLoadImage
          src={url}
          alt={alt}
          onLoad={() => setIsLoading(false)}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
          }}
        />
        {isLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
            }}
          >
            <CustomSpinner />
          </div>
        )}
      </div>
    </>
  );
};

export default ImageWrapper;
